var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector27(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 307,
    viewBox: "0 0 130 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.155 306.764C304.767 287.849 301.06 283.73 286.244 264.321C282.614 259.566 276.902 250.322 271.447 238.905C269.812 235.488 268.33 232.1 266.971 228.759C257.277 204.852 255.909 178.069 258.161 151.618C263.911 84.129 227.379 23.2171 172.068 5.45979C116.662 -12.326 55.1355 16.9342 25.1136 62.5944C21.2076 68.5357 3.97752 96.5715 1.43055 127.331C-6.63801 224.451 87.4382 263.258 230.582 292.642C233.366 293.211 246.624 295.385 249.437 295.774L328.165 306.774L328.155 306.764Z",
    fill: "#1E1E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector27);
export default __webpack_public_path__ + "static/media/vector2-7.99a0fb03f6b100e740e4453a800efc23.svg";
export { ForwardRef as ReactComponent };